import { AfterViewInit, Component, EventEmitter, OnInit, Output } from '@angular/core';

@Component({
  selector: 'rl-bootstrap-services',
  templateUrl: './bootstrap-services.component.html'
})
export class BootstrapServicesComponent implements AfterViewInit{

  @Output() onInit = new EventEmitter<void>();

  constructor() { }

  ngAfterViewInit(): void {
    this.onInit.emit();
  }

}
